export default __webpack_public_path__ + "static/thickness-7dc514e9da1a73e780e96a92c0b7ca8a.png";